module.exports = __webpack_public_path__ + "static/media/2020-02-26-01.46204ac8.jpg";